export const Privacy = () => {
  return (
    <div id='privacy'>
      <div className='container'>
        <div className='section-title text-center'>
          <h2>Privacy</h2>
        </div>
        <div>
          <h2>Privacy Policy</h2>
        </div>
        <div>
          <h3>Our Mission</h3>
        </div>
        <div>
          <p>We are sensitive to the private nature of the information you, our service providers, partners, end-users and prospective end-user customers provide to us. Our Privacy Policy is designed to maximize your ability to protect your personal, private data while at the same time allowing us to provide you with the best interactive security, energy management, video monitoring, automation and wellness services possible. This Privacy Policy states our privacy practices for your use of (i) this website and any mobile sites or applications operated by OGN Tech (the “User Interfaces”) and (ii) any combination of products and services we provide or that can be purchased or accessed via any User Interface (the “Services”). </p>
        </div>
        <div>
          <h3>Information Collection and Use</h3>
        </div>
        <div>
          <p>OGN Tech collects and processes certain information from or about you that can be used to identify you (“Personal Information”). This information is collected to provide, improve, and secure our services.</p>

          <p>The types of data we may collect include:</p>
          <ul>
            <li><strong>Personal Identifiers:</strong> Name, email address, phone number, home or business address</li>
            <li><strong>Device Information:</strong> Device model, operating system, app version, and identifiers</li>
            <li><strong>Location Data:</strong> GPS location collected from your device</li>
            <li><strong>Health Data:</strong> Data collected from connected health watches, including but not limited to heart rate, activity levels, and other health-related metrics</li>
          </ul>

          <p>We collect this information when you:</p>
          <ul>
            <li>Register or use our mobile application</li>
            <li>Connect a health watch or related device</li>
            <li>Interact with features within the app</li>
          </ul>

        </div>
        <div>
          <h3>Use of Data</h3>
        </div>
        <div>
          <p>We use the collected data for the following purposes:</p>
          <ul>
            <li>To provide core app functionality (e.g., health monitoring, alerts, and reporting)</li>
            <li>To enable location sharing with users you explicitly approve</li>
            <li>To improve app performance and user experience</li>
            <li>To ensure safety features (e.g., health monitoring and emergency alerts)</li>
          </ul>

          <p><strong>Health Data Usage:</strong><br />
            Health data collected from your device is used solely to provide health monitoring features within the app. We do not sell, rent, or use health data for advertising purposes.</p>

          <h3>Data Sharing and Disclosure</h3>
          <p>We do <strong>not sell or trade your personal or health data</strong>.</p>

          <p>We may share your data only in the following cases:</p>
          <ul>
            <li>With users you explicitly authorize (e.g., sharing your location or health data)</li>
            <li>With service providers strictly necessary to operate the app (e.g., secure cloud storage), under confidentiality obligations</li>
            <li>When required by law, regulation, or legal process</li>
          </ul>

          <h3>Location-Based Information</h3>
          <p>Our application collects GPS location data from connected devices or your mobile device.</p>
          <ul>
            <li>Location data is only stored on the mobile device and not in our cloud systems as it is only used for custom user experience. </li>
            <li>We do not use location data for advertising or analytics unrelated to core functionality</li>
          </ul>

          <h3>Data Retention</h3>
          <p>We retain your personal, location, and health data only for as long as necessary to:</p>
          <ul>
            <li>Provide the services requested by you</li>
            <li>Comply with legal obligations</li>
            <li>Resolve disputes and enforce agreements</li>
          </ul>

          <p><strong>Health Data Retention:</strong><br />
            Health data collected from your device is retained for a maximum of <strong>10 days</strong>, after which it is automatically deleted from our systems, unless a longer retention period is required by law.</p>

          <p>Personal and location data is retained only while your account is active. If your account becomes inactive or is deleted, we will delete or anonymize your data within a reasonable timeframe, unless retention is required for legal or regulatory purposes.</p>

          <h3>Data Deletion and User Rights</h3>
          <p>You have the right to request deletion of your data at any time.</p>

          <p>You can request deletion by:</p>
          <ul>
            <li>Submitting a request through the <strong>“Contact Us”</strong> form available on our website</li>
          </ul>

          <p>Upon receiving a valid request:</p>
          <ul>
            <li>Your personal, location, and health data will be deleted from our active systems within a reasonable timeframe (typically within 30 days)</li>
            <li>Some data may be retained if required for legal or regulatory compliance</li>
          </ul>

        </div>
        <div>
          <h3>Privacy Policy Changes</h3>
        </div>
        <div>
          <p>We may change this Privacy Policy at any time. Any changes to this Privacy Policy will be posted on our User Interfaces. This Privacy Policy is not intended to and does not create any contractual or other legal right in or on behalf of any party.</p>
        </div>
        <div>
          <h3>Contact Information</h3>
        </div>
        <div>
          <p>If you have any questions, concerns, or suggestions regarding this Privacy Policy, please contact us at:</p>
          <p>privacy@ogn.co.nz</p>
        </div>
        {/* <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  <div className='testimonial'>
                    <div className='testimonial-image'>
                      {' '}
                      <img src={d.img} alt='' />{' '}
                    </div>
                    <div className='testimonial-content'>
                      <p>"{d.text}"</p>
                      <div className='testimonial-meta'> - {d.name} </div>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div> */}
      </div>
    </div>
  )
}
